/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Search_Error_ToastInputs */



/**
* | output |
* | --- |
* | "An error occurred while searching." |
*
* @param {Error_Nav_Search_Error_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_search_error_toast = /** @type {((inputs?: Error_Nav_Search_Error_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Search_Error_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Une erreur s'est produite lors de la recherche.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bei der Suche ist ein Fehler aufgetreten.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Si è verificato un errore durante la ricerca.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("При поиске произошла ошибка.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se produjo un error durante la búsqueda.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("搜索过程中发生错误。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("検索中にエラーが発生しました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खोज करते समय एक त्रुटि उत्पन्न हुई।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ocorreu um erro durante a pesquisa.")
	return /** @type {LocalizedString} */ ("An error occurred while searching.")
});